































































































































































import { Vue, Component, Lifecycle, Prop, p, Watch } from "av-ts";
import * as d3 from "d3";

@Component()
export default class Treemap extends Vue {

    @Prop labels = p<any>({
        required: true
    });

    @Prop datasets = p<any>({
        required: true
    });

    childData = [];
    processData = {};

    treemapData() {
        //Currently values are set to be the same across all values, competency dictates color, might have to update if we get more levels
        //so other levels also have competency value
        if (this.labels !== undefined) {
            this.childData = this.labels.map((label: any) => {
                let index = this.labels!.indexOf(label);
                if (this.datasets !== undefined && this.datasets[0] !== undefined) {
                    const point = this.datasets[0];
                    if (point.data !== undefined) {
                        const node = {
                            "competency": point.data[index],
                            "name": label,
                            "value": 50
                        };
                        return node;
                    }
                }
            });
        }
    }

    rootNode: any = {};
    width = 900; // % of the parent element
    height = 530;
    margin: any = {
        top: 20,
        right: 20,
        bottom: 0,
        left: 0
    };
    selected = null;
    
    get parentId() {
        if (this.selectedNode.parent === undefined || this.selectedNode.parent === null) {
            return this.selectedNode.id;
        } else {
            return this.selectedNode.parent.id;
        }
    }

    get selectedNode() {
        let node = undefined;
        if (this.selected) {
            const nd = this.getNodeById(this.rootNode, this.selected, this);
            if (nd.children) {
                node = nd;
            } else {
                node = nd.parent;
            }
        } else {
            node = this.rootNode;
        }

        this.x.domain([node.x0, node.x0 + (node.x1 - node.x0)]);
        this.y.domain([node.y0, node.y0 + (node.y1 - node.y0)]);
        return node;
    }

    get x() {
        return d3.scaleLinear()
            .domain([0, this.width])
            .range([0, this.width]);
    }

    get y() {
        return d3.scaleLinear()
            .domain([0, this.height - this.margin.top - this.margin.bottom])
            .range([0, this.height - this.margin.top - this.margin.bottom]);
    }

    get treemap() {
        return d3.treemap()
            .size([this.width, this.height])
            .round(false)
            .paddingInner(0);
    }
    
    @Lifecycle
    mounted() {
        const that = this;
        const parentDivElement = (this.$refs.parentDiv as HTMLDivElement).parentElement;
        if (parentDivElement !== null) {
            this.height = parentDivElement.clientHeight;
            this.width = parentDivElement.clientWidth;
        }
        this.treemapData();
        this.processData = { "name": "Treemap",
            "value": 0,
            "children": this.childData
        };
        
        that.initialize();
        that.sumChildren(that.rootNode, that);
        that.treemap(that.rootNode);
    }

    @Watch("labels")
    handleDataChange(_newData: any, _oldData: any) {
        const that = this;
        this.treemapData();
        this.processData = { "name": "Treemap",
            "value": 0,
            "children": this.childData
        };
        
        that.initialize();
        that.sumChildren(that.rootNode, that);
        that.treemap(that.rootNode);
    }

    getColor(value: number) {
        let color: any;
        if (value > 0) {
            color = d3.scaleQuantize<String>().domain([1, 100])
                .range(["pink", "#fbe7b7", "#256"]);
            return color(value);
        } else {
            return "gray";
        }
    }

    initialize() {
        const that = this;
        if (this.processData) {
            //FIX: any typing as cannot add id dynamically
            //Sum function is also only calculating leaf nodes as it seems unable to calculate parents, hence sum children called afterwards
            that.rootNode = d3.hierarchy(that.processData)
                .eachBefore((d:any) => {
                    d.id = (d.parent ? d.parent.id + ".": "") + d.data.name;
                }).sum((d: any):number => {
                    return d.value;
                }).sort(function(a:any, b:any) {
                    return b.heigth - a.heigth || b.value - a.value;
                });
            that.rootNode.x = that.rootNode.y = 0;
            that.rootNode.x1 = that.width;
            that.rootNode.y1 = that.height;
            that.rootNode.depth = 0;
        }
    }

    sumChildren(node: any, context: any): number {
        let sum = 0;
        if (node) {
            node.children.forEach((child: any) => {
                if (child.children) {
                    sum += context.sumChildren(child.children);
                } else {
                    sum += child.value;
                }
            });
        } else {
            return node.value;
        }
        return sum;
    }

    //fix types
    getNodeById(node: any, id: any, context: any) {
        let selectedNode: any;
        if (node.id === id) {
            return node;
        } else if (node.children) {
            node.children.forEach((childNode:any) => {
                const nd = context.getNodeById(childNode, id, context);
                if (nd) {
                    selectedNode = nd;
                }
            });
        }
        return selectedNode;
    }

    //fix types
    selectNode(event:any) {
        this.selected = event.target.id;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/charts/Treemap.vue